
(function(template){
  define('vue!optionalClassProgram/components/classComponents/optionalComponents/groupedClassesComponent',[
    "Vue",
    "helpers",
    "vuex",
    "moment",
    'vue!../../helperComponents/checkbox',
    "vue!./singleClassComponent",
  ], function (
    Vue,
    helpers,
    vuex,
    moment,
    checkbox,
    singleClassComponent
  ) {
    return {
      template: template,
      name: "",
      props: ['customerID','propertyName','oIndex','optionalClasses','classes'],
      data: function () {
        return {
            error: "",
            showBodyContent: false,
            hasAllGroupedClasses: {},
            invalidGroupClasses: {}
        }
      },
      computed: _.extend(
        vuex.mapState(['users']), {
            generateErrorMessage: function(){
                this.error = this.localStrings.ageRestriction.optionalClass.optionalClassCascadedErr
            },

        }),
      components: {
          'checkbox':checkbox,
          'singleClassComponent':singleClassComponent
      },
      methods: {
          handleCheckBoxClick: function (checked, item, parentCascade, cascadeCheckbox,isPartiallyGrouped) {
              var action = !checked ? (!isPartiallyGrouped || isPartiallyGrouped && _.isEmpty(this.invalidGroupClasses))? 'add' : 'remove':'remove' //if cascaded checkbox is in partial selected stage, and if it is because there is atleast one class that didnt the age requirment, then upon clicking cascadedbox again, uncheck whole grouped classes. Otherwise, check all
              var self = this;
              var tempObj = {}
              if (!!cascadeCheckbox) {
                  var groupedClasses = self.optionalClasses[cascadeCheckbox]
                  _.each(groupedClasses, function (items) {
                      var isValid = self.verifyAge(items, self.customerID)
                      if (isValid) {
                          self.$store.commit('configureOptionalSpaItemId', {
                              userId: self.customerID,
                              SpaClassId: items.SpaClassId,
                              action: action
                          })
                          delete tempObj[items.SpaClassId] //if exists
                      } else tempObj[items.SpaClassId] = true
                  })
                  self.invalidGroupClasses = _.extend({}, tempObj)
                  if (!_.isEmpty(self.invalidGroupClasses)) {
                      self.generateErrorMessage
                  } else self.error = ''
              }
          },
           hasPartialClasses: function (parentCascade) {
               var self = this;
               var optionalClassListIds = self.users[self.customerID].optionalClassListIds || {}
               var partial = false
               var count = 0;
               var cascadedClasses = self.optionalClasses[parentCascade]
               if (!_.isEmpty(optionalClassListIds)) {
                   _.each(cascadedClasses, function (item) {
                       optionalClassListIds[item.SpaClassId] ? count++ : ''
                   })
                   partial = (count != 0 && count != cascadedClasses.length)
                   self.hasAllGroupedClasses[parentCascade] = !partial && !!count
               } else self.hasAllGroupedClasses[parentCascade] = false
               return partial;
               //  }
           }
      },
    }
  })
})('<div> <div class="accordion-heading" v-if="propertyName != \'N\'"> <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion2" :data-target="\'#o\'+oIndex+customerID"> <p class="inner-service-error"><strong v-if="error">{{error}}</strong></p> <checkbox :cascadeCheckbox="propertyName" :partiallyGrouped="hasPartialClasses(propertyName)" :selected="hasAllGroupedClasses[propertyName]" @handle-checkbox-click="handleCheckBoxClick"> </checkbox> <span class="optionalclass-accordion-header-text"> {{propertyName.split(\'|\')[0]}}</span> </a> </div> <div :id="\'o\'+oIndex+customerID" class="accordion-body collapse " :class="propertyName == \'N\' ? \'in\': \'\'"> <div v-for="(item, classindex) in classes" :key="classindex" :class="propertyName != \'N\'?\'optionalclass-accordion-body-text-parent\':\'optionalclass-noCascade\'"> <singleClassComponent v-bind:customerID="customerID" v-bind:propertyName="propertyName" v-bind:groupingIndex="oIndex" v-bind:item="item" v-bind:invalidGroupClasses="invalidGroupClasses"></singleClassComponent> </div> </div> </div>');
